import { Carousel } from 'react-responsive-carousel';
import TruckAtlanta from '../assets/AtlantaTruck.jpg';
import Trailers from '../assets/trailers.png';
import TruckFront from '../assets/truck-front.png'

export default () => (
    <Carousel autoPlay>
        <div className="ds-image-one">
            <img src={TruckAtlanta} alt="digital" />
        </div>
        <div className="ds-image-two">
            <img src={TruckFront} alt="image 2" />
        </div>
        <div className="ds-image-three">
        <img src={Trailers} alt="Trailers" />
        </div>



    </Carousel>
)